import { render, staticRenderFns } from "./BookingInfoDialog.vue?vue&type=template&id=58612732"
import script from "./BookingInfoDialog.vue?vue&type=script&lang=ts"
export * from "./BookingInfoDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports